import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { CostsPerEmployeeGroup } from '../../../models/cost-per-employee-group';
import { NgForm } from '@angular/forms';
import { Division } from '../../../models/division';
import { Area } from '../../../models/area';
import { CostsPerEmployee } from '../../../models/cost-per-employee';
import { AlertaService } from '../../../services/alerta.service';
import { findAreasCatalogAct, findCostsPerEmployeesCatalogAct, findCostsPerEmployeeTypeCatalogAct, findDivisionsCatalogAct } from '../../../store/catalog-offer/catalog-offer.actions';
import { select, Store } from '@ngrx/store';
import { ActivatedRoute } from '@angular/router';
import { distinctUntilChanged, map } from 'rxjs';
import { findCostsPerEmployeeGroupAct, resetCostsPerEmployeeGroupAct, saveCostsPerEmployeeGroupAct, updateCostsPerEmployeeGroupAct } from '../../../store/cost-per-employees-group/cost-per-employee-group.action';
import { CostsPerEmployeeConfiguration } from '../../../models/cost-per-employee-configuration';
import { CostsPerEmployeeType } from '../../../models/cost-per-employee-type';

@Component({
  selector: 'app-cost-per-employees-add',
  standalone: false,
  templateUrl: './cost-per-employees-add.component.html',
  styleUrl: './cost-per-employees-add.component.css'
})
export class CostPerEmployeesAddComponent {

costsPerEmployeeGroupForm!: NgForm;
costsPerEmployeeGroup: CostsPerEmployeeGroup = new CostsPerEmployeeGroup();
loading: boolean = false;
violations: any;
divisions: Division[] = [];
areas: Area[] = [];
costsPerEmployees: CostsPerEmployee[] = [];
private alerta = inject(AlertaService);

ngOnInit(): void {
  this.costsPerEmployeeGroupStore.dispatch(resetCostsPerEmployeeGroupAct());
  this.route.paramMap.subscribe(params => {
    const id: number = + (params.get('id') || '0');
    if(id > 0){
      this.costsPerEmployeeGroupStore.dispatch(findCostsPerEmployeeGroupAct({ id }));
    }else{
      this.costsPerEmployeeGroup = new CostsPerEmployeeGroup();
      //this.costsPerEmployeeGroup.active = true;
      this.loading = false;
    }
  });

  this.catalogOfferStore.dispatch(findDivisionsCatalogAct());
  this.catalogOfferStore.dispatch(findAreasCatalogAct());
  this.catalogOfferStore.dispatch(findCostsPerEmployeesCatalogAct());

}
constructor(
  private costsPerEmployeeGroupStore: Store<{costsPerEmployeeGroupRdc: any}>,
  private catalogOfferStore: Store<{catalogOfferRdc: any}>,
  private route: ActivatedRoute,
  private cd: ChangeDetectorRef
){
  this.costsPerEmployeeGroup = new CostsPerEmployeeGroup();

  this.costsPerEmployeeGroupStore.pipe(
    select('costsPerEmployeeGroupRdc'),
    map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
      costsPerEmployeeGroup: state.costsPerEmployeeGroup,
      violations: state.violations,
      loading: state.loading
    })),
    // evita repeticiones
    distinctUntilChanged((prev, curr) =>
      JSON.stringify(prev) === JSON.stringify(curr)
    )
  ).subscribe(({ costsPerEmployeeGroup, violations, loading }) => {
    this.violations = violations;
    this.costsPerEmployeeGroup = JSON.parse(JSON.stringify(costsPerEmployeeGroup));
    // Ordenar lista de vacaciones 
    this.costsPerEmployeeGroup.costsPerEmployeeConfigurations.sort((a, b) =>  a.costsPerEmployee.description.localeCompare(b.costsPerEmployee.description, 'es', { sensitivity: 'base' }) );
    /*this.costsPerEmployeeGroup.costsPerEmployeeConfigurations.forEach(costsPerEmployeeConfiguration => {
      costsPerEmployeeConfiguration.sort((a, b) => a.initialYear - b.initialYear);
    });*/
    this.loading = loading;
    this.cd.markForCheck(); // fuerza la actualización de la vista

    if(this.costsPerEmployeeGroupForm){
      Object.keys(this.costsPerEmployeeGroupForm.controls).forEach(controlName => {
        const control = this.costsPerEmployeeGroupForm.controls[controlName];
        if (this.violations[controlName]) {
          control.setErrors({ backend: true }); // Marca error
        }
      });
    }
  });

  this.catalogOfferStore.pipe(
    select('catalogOfferRdc'),
    map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
      divisions: state.divisions,
      areas: state.areas,
      costsPerEmployees: state.costsPerEmployees
    })),
    // evita repeticiones
    distinctUntilChanged((prev, curr) =>
      JSON.stringify(prev) === JSON.stringify(curr)
    )
  ).subscribe(({ divisions, areas, costsPerEmployees }) => {
    this.divisions = divisions;
    this.areas = areas;
    this.costsPerEmployees = costsPerEmployees;
  });
  
}

onSubmitCostsPerEmployeeGroup(costsPerEmployeeGroupForm: NgForm): void {
  this.loading = true;
  this.costsPerEmployeeGroupForm = costsPerEmployeeGroupForm;
  const costsPerEmployeeGroupCopy = JSON.parse(JSON.stringify(this.costsPerEmployeeGroup));

  if (costsPerEmployeeGroupCopy.id > 0) {
    this.costsPerEmployeeGroupStore.dispatch(updateCostsPerEmployeeGroupAct({ costsPerEmployeeGroupUpdated: costsPerEmployeeGroupCopy }))
  } else {
    this.costsPerEmployeeGroupStore.dispatch(saveCostsPerEmployeeGroupAct({ costsPerEmployeeGroupNew: costsPerEmployeeGroupCopy }))
  }
}

addCostsPerEmployeeConf(){
  const newCostsPerEmployeeConfigurations = new CostsPerEmployeeConfiguration();
  this.costsPerEmployeeGroup.costsPerEmployeeConfigurations = [...this.costsPerEmployeeGroup.costsPerEmployeeConfigurations, newCostsPerEmployeeConfigurations ];
}

  hoveredRow: number | null = null;
  hoveredCol: number | null = null;

  isSelected(listIndex: number, divisionId: number, areaId: number): boolean {
    const list = this.costsPerEmployeeGroup.costsPerEmployeeConfigurations?.[listIndex];
    return list?.costsPerEmployeeDivisionAreaList.some(d =>
      d.id.divisionId === divisionId && d.id.areaId === areaId
    ) ?? false;
  }

  onCheckboxChange(listIndex: number, division: Division, area: Area, event: any): void {
    const checked = event.target.checked;
    const list = this.costsPerEmployeeGroup.costsPerEmployeeConfigurations?.[listIndex];
    if (!list) return;
  
    const index = list.costsPerEmployeeDivisionAreaList.findIndex(d =>
      d.id.divisionId === division.id && d.id.areaId === area.id
    );
  
    if (checked && index === -1) {
      // Agrega nuevo vínculo
      list.costsPerEmployeeDivisionAreaList.push({
        id: {
          holidayListId: list.id,
          divisionId: division.id,
          areaId: area.id
        },
        division,
        area
      });
    } else if (!checked && index !== -1) {
      // Elimina vínculo
      list.costsPerEmployeeDivisionAreaList.splice(index, 1);
    }
  }
  onMouseEnter(row: number, col: number) {
    this.hoveredRow = row;
    this.hoveredCol = col;
  }

  onMouseLeave() {
    this.hoveredRow = null;
    this.hoveredCol = null;
  }

  compareCostsPerEmployee = (a: any, b: any) => a?.id === b?.id;

}
